import React, { useState, useEffect } from 'react';

import { isEmpty } from 'lodash';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { 
    TreeList, 
    orderBy, 
    filterBy, 
    mapTree, 
    extendDataItem
} from '@progress/kendo-react-treelist';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobLoadingMask from '../../../components/BobLoadingMask';

import * as DashboardActions from '../../../actions/dashboardActions';
import * as RoleActions from '../../../actions/roleActions';

import { connect } from 'react-redux';

import classes from '../CreateEntityModal.module.css';
import * as treeListClasses from '../TreeList.module.css';

const subItemsField = 'subItems';
const expandField = 'expanded';

const AddOrEdit = ({
    activeNavCompany,
    allActiveScopes,
    availableScopes,
    bobLoading,
    contextState,
    createRole,
    currentUser,
    deleteExistingUserScopes,
    existingUserContext,
    isCompanyLevelAccess,
    fetchRole,
    isCreateRole,
    onCancelClick,
    selectedRole,
    selectedClient,
    selectedSite,
    selectedUser,
    clientList,
    setClientList,
    siteList,
    setSiteList,
    type,
    userApplications,
    updateRole,
    uncheckedCompanyLevelAccess,
    updateUserContextWithScopes,
    ...props
}) => {
    const [state, setState] = useState({});
    const [roleName, setRoleName] = useState('');
    
    // edit role
    useEffect(() => {
        async function init() {
            const scopeData = [ ...allActiveScopes ];
            const roleData = await fetchRole(selectedRole.id);

            let allScopes = [];
            scopeData.forEach(scope => {
                let tempRole = roleData.scopes.filter(data => data.id === scope.id);
                if (!isEmpty(tempRole)) {
                    let tempList = [];

                    // add missing subItems
                    scope.subItems.forEach(item => {
                        let tempSubItems =  tempRole[0].subItems.filter(s => s.name === item.name);
                        if (!isEmpty(tempSubItems)) {
                            tempList.push(tempSubItems[0]);
                        } else {
                            tempList.push(item); 
                        }
                    });

                    tempRole[0].subItems = tempList;

                    tempRole[0].subItems.forEach(item => {
                        let tempSubItems = scope.subItems.filter(d => d.name === item.name);

                        // add missing scopes
                        item.operations.read = { ...tempSubItems[0].operations.read, checked: item.operations.read.checked };
                        item.operations.create = { ...tempSubItems[0].operations.create, checked: item.operations.create.checked };
                        item.operations.update = { ...tempSubItems[0].operations.update, checked: item.operations.update.checked };
                        item.operations.delete = { ...tempSubItems[0].operations.delete, checked: item.operations.delete.checked };
                    });

                    allScopes.push({ ...tempRole[0] });
                } else {
                    allScopes.push({...scope});
                }
            });

            setRoleName(roleData.roleName);
            setState({
                data:      [...allScopes],    
                dataState: {
                    sort: [{
                        field: 'name',
                        dir:   'asc'
                    }],
                    filter: []
                },
                expanded: []
            });
        }

        if (selectedRole && selectedRole.id) init();
    }, [selectedRole]);

    // create role
    useEffect(() => {
        async function init() {
            setState({
                data:      [...allActiveScopes],
                dataState: {
                    sort: [{
                        field: 'name',
                        dir:   'asc'
                    }],
                    filter: []
                },
                expanded: []
            });
        }

        if (allActiveScopes && !isEmpty(allActiveScopes) && isEmpty(selectedRole) && type !== 'RolePermissionTab' ) init();
    }, [allActiveScopes]);

    // from RolePermissionTab
    useEffect(() => {
        async function init() {
            const scopeData = [ ...availableScopes ];
            const scopeIds = availableScopes.map(item => item.id);

            setState({
                data:      [...scopeData],
                dataState: {
                    sort: [{
                        field: 'name',
                        dir:   'asc'
                    }],
                    filter: []
                },
                expanded: [...scopeIds]
            });
        }
    
        if (type === 'RolePermissionTab')  init();
    }, [availableScopes]);

    const handleFullAccessChange = (e, dataItem) => {
        let scopes = state.data;
        let dataObj = {...dataItem};

        let access = !dataObj.fullAccess ? true : false;

        if (access) {
            dataObj.subItems.forEach(item => {
                item.operations.read = item.operations.read && item.operations.read.id ? { ...item.operations.read, checked: true } : null;
                item.operations.create = item.operations.create && item.operations.create.id ? { ...item.operations.create, checked: true } : null;
                item.operations.update = item.operations.update && item.operations.update.id ? { ...item.operations.update, checked: true } : null;
                item.operations.delete = item.operations.delete && item.operations.delete.id ? { ...item.operations.delete, checked: true } : null;
            });
        }
    
        scopes.forEach(element => {
            if (element.id === dataObj.id) {
                element.subItems = dataObj.subItems;
                element.fullAccess = access;
            }
        });

        setState({
            data: [...scopes],
            ...state
        });
    };

    const handleScopeChange = (e, dataItem) => {
        let scopes = state.data;

        let tempScope = scopes.filter(item => item.name === dataItem.applicationName );
        let tempSubItem = tempScope[0].subItems.filter(s => s.id === dataItem.id);
        let key = false;

        if (tempSubItem[0]['operations'][e.target.name].checked === false) {
            key = true;
        }

        tempSubItem[0]['operations'][e.target.name].checked = key;

        scopes.forEach(element => {
            if (element.id === dataItem.id) {
                element = tempScope;
            }
        });

        setState({
            data: [...scopes],
            ...state
        });
    };
    
    const CheckboxCell = props => {
        const { dataItem } = props;
        const field = props.field;
        let isEnabled = '';
        
        if (dataItem.operations) {
            isEnabled = dataItem.operations[field] && dataItem.operations[field].id ? true  : false;
        } else {
            if (field === 'read') {
                return (
                    <td className={props.className} style={props.style}>
                        <Checkbox
                            classes={{
                                root: classes.Checkbox
                            }}
                            checked={dataItem.fullAccess ? true : false}
                            onChange={(e) => handleFullAccessChange(e, dataItem)}
                            name={field}
                            style={{
                                color:     'black',
                                transform: 'scale(1.5)',
                            }}
                            disableRipple
                        />
                        <span>Full Access</span>
                    </td>
                );
            }
        }
        
        return (
            <td className={props.className} style={props.style}>
                {
                    isEnabled ?
                        <Checkbox
                            classes={{
                                root: classes.Checkbox
                            }}
                            checked={dataItem.operations[field].checked ? true : false}
                            onChange={(e) => handleScopeChange(e, dataItem)}
                            name={field}
                            style={{
                                color:     'black',
                                transform: 'scale(1.5)',
                            }}
                            disableRipple
                        /> : null 
                }
            </td>
        );
    };

    const columns = [
        {
            field:      'name',
            title:      'Function',
            width:      '100px',
            filter:     '',
            expandable: true
        },
        {
            field:    'read',
            title:    'Read',
            width:    '50px',
            filter:   '',
            sortable: false,
            cell:     CheckboxCell
        },
        {
            field:    'create',
            title:    'Create',
            width:    '50px',
            format:   '{0:d}',
            filter:   '',
            sortable: false,
            cell:     CheckboxCell
        },
        {
            field:    'update',
            title:    'Edit',
            width:    '50px',
            filter:   '',
            sortable: false,
            cell:     CheckboxCell
        },
        {
            field:    'delete',
            title:    'Delete',
            width:    '50px',
            filter:   '',
            sortable: false,
            cell:     CheckboxCell
        }
    ];

    const onExpandChange = e => {
        setState({
            ...state,
            expanded: e.value ? state.expanded.filter(id => id !== e.dataItem.id) : [...state.expanded, e.dataItem.id]
        });
    };

    const handleDataStateChange = event => {
        setState({
            ...state,
            dataState: event.dataState
        });
    };

    const addExpandField = dataTree => {
        const expanded = state.expanded;
        return mapTree(dataTree, subItemsField, item => extendDataItem(item, subItemsField, {
            [expandField]: expanded.includes(item.id)
        }));
    };

    const processData = () => {
        let {
            data,
            dataState
        } = state;
        let filteredData = filterBy(data, dataState.filter, subItemsField);
        let sortedData = orderBy(filteredData, dataState.sort, subItemsField);
        return addExpandField(sortedData);
    };

    const createOrUpdateRole = async () => {
        let tempData = [...state.data];
        let scopes = [];

        tempData.forEach(role => {
            role.subItems.forEach(item => {
                let hasChange = false;
                let scopeItem = {
                    'applicationId':   item.applicationId,
                    'applicationName': item.applicationName,
                    'scopeFunction':   item.name,
                    'operations':      {
                        'read':   null,
                        'create': null,
                        'update': null,
                        'delete': null
                    }
                };

                Object.keys(item.operations).forEach(operationName => {
                    if (item.operations[operationName] && item.operations[operationName].checked) {
                        hasChange = true;
                        scopeItem.operations[operationName] = item.operations[operationName].id && item.operations[operationName].checked ? item.operations[operationName].id : null;
                    }
                });

                if (hasChange) {
                    scopes.push(scopeItem);
                }
            });
        });

        if (!isEmpty(scopes) && roleName) {
            let body = {
                'roleName': roleName,
                'status':   'Active',
                'scopes':   scopes
            };

            if (isCreateRole) {
                let isCreated = await createRole(body);
                if (isCreated) {
                    onCancelClick();
                }
            } else {
                body.id = selectedRole.id;
                await updateRole(body);
                onCancelClick();
            }
        }
    };

    const handleNameChange = e => {
        setRoleName(e.target.value);
    };

    const getUserScopes = data => {
        let tempData = [...data];
        let tempScopes = [];

        tempData.forEach(role => {
            role.subItems.forEach(item => {
                Object.keys(item.operations).forEach(operationName => {
                    if (item.operations[operationName] && item.operations[operationName].checked) {
                        tempScopes.push({
                            'scopeId':     item.operations[operationName].id,
                            'activeState': 0
                        });
                    }
                });
            });
        });

        return tempScopes;
    };

    const assignPermission = async () => {
        let roleIds = selectedRole.map(role => role.id);
        let clientId = null;
        let siteId = null;
        let userScopes = [];

        if (!isEmpty(availableScopes)) {
            userScopes = getUserScopes(availableScopes);
        }

        if (isCompanyLevelAccess) {
            clientId = null;
            siteId = null;
        } else if (!isEmpty(clientList) && selectedClient && selectedClient.id) {
            clientId = selectedClient.id;

            if (selectedClient.autoAddSite) {
                siteId = null;
            } else {
                siteId = selectedSite.map(item => item.id);
            }
        }
        
        // remove select all option value
        roleIds = roleIds.filter(r => r !== 0);
        siteId = siteId ? siteId.filter(s => s !== 0) : siteId;

        const payload = {
            'roleIds':    roleIds,
            'clientId':   clientId,
            'siteId':     siteId,
            'userScopes': userScopes
        };

        let isValid = true;

        // delete existing user scopes
        if (!isEmpty(existingUserContext)) {
            let deletePayload = {
                'clientId': null,
                'siteId':   null,
            };

            // remove all existing client and site access
            if (uncheckedCompanyLevelAccess) {
                deletePayload = {
                    'clientId': null,
                    'siteId':   null,
                };
            } else {
                let tempContext = contextState.data;
                // remove existing client access
                let removedClients = tempContext.filter(c => c.unchecked && c.isExisting);
                if (!isEmpty(removedClients)) {
                    let clientIds = removedClients.map(rc => rc.id);
                    deletePayload = {
                        'clientId': clientIds,
                        'siteId':   null,
                    };
                } else {
                    tempContext.forEach(c => {
                        // remove existing site access
                        let removedSites = c.subItems.filter(s => s.unchecked && s.isExisting);
                        if (!isEmpty(removedSites)) {
                            let siteIds = removedSites.map(rs => rs.id);
                            deletePayload = {
                                'clientId': c.id,
                                'siteId':   siteIds,
                            };
                        }
                    });
                }
            }

            let resp = await deleteExistingUserScopes(selectedUser.id, activeNavCompany.id, deletePayload);
            isValid = resp ? true : false;
        }
        
        if (isValid) {
            await updateUserContextWithScopes(selectedUser.id, activeNavCompany.id, payload);
        }
    };

    return (
        <div className={type === 'RolePermissionTab' ? '' : classes.userformColumn}>
            {
                type !== 'RolePermissionTab' ?
                    <FormControl className={classes.roleNameinputWrapperHalf}>
                        <TextField
                            variant="outlined" 
                            size="small"
                            id="name"
                            name="name"
                            type="text"
                            value={roleName}
                            label={<span>Role Name<span className={classes.required}> * </span></span>}
                            onChange={handleNameChange}
                            InputLabelProps={{
                                classes: {
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }
                            }}
                        />
                    </FormControl>
                    : null 
            }
            {
                !isEmpty(state.data) ?
                    <div>
                        <TreeList
                            style={{
                                maxHeight: '64vh',
                                maxWidth:  '105rem',
                                overflow:  'auto'
                            }}
                            className={treeListClasses.RolesTable}
                            expandField={expandField} 
                            subItemsField={subItemsField}
                            onExpandChange={onExpandChange} 
                            sortable={{
                                mode: 'multiple'
                            }} {...state.dataState}
                            data={processData()} 
                            onDataStateChange={handleDataStateChange} 
                            columns={columns}
                        />
                    </div> : null 
            }
            <div className={classes.userButtons}>
                <Button
                    className={classes.Button}
                    variant="contained"
                    onClick={() => onCancelClick()}
                >
                    Cancel
                </Button>
                {
                    type !== 'RolePermissionTab' ?
                        <BobConfirmButton
                            className={classes.ButtonWithMargin}
                            label={isCreateRole ? 'Save' : 'Update'}
                            onClick={() => createOrUpdateRole()}
                        />: null
                }
                {
                    type === 'RolePermissionTab' && !isEmpty(state.data) ?
                        <BobConfirmButton
                            className={classes.ButtonWithMargin}
                            label={'Assign'}
                            onClick={() => assignPermission()}
                        /> : null  
                }
            </div>
            {
                bobLoading.includes('createRole') || bobLoading.includes('fetchRole') || 
                bobLoading.includes('updateRole') ?
                    <BobLoadingMask
                        className={classes.Loader}
                    />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        bobLoading:       state.bob.bobLoading,
        currentUser:      state.currentUser,
        allActiveScopes:  state.roles.allActiveScopes
    };
};

const mapDispatchToProps = {
    ...DashboardActions,
    ...RoleActions
};

export default connect(mapStateToProps, mapDispatchToProps)(AddOrEdit);
